//
// Module for the Workflow Assign Work Index view
//
rs.module("workflow/activity/assignwork/index",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, modes) {

            var filter = $.js(jsSelectors.filter);
            var modeRadioContainer = filter.js(jsSelectors.modeRadioContainer);
            var workflowUserSelect = filter.js(jsSelectors.workflowUserSelect);

            // Build select helpers to expand drop down functionality
            var workflowUserSelectHelper = selectHelper.getHelper(workflowUserSelect);

            // Setup listeners on filter inputs to perform actions
            modeRadioContainer.find("input").on("click", () => modeChanged());

            // Handle the mode changed event
            function modeChanged() {

                var mode = modeRadioContainer.find("input:checked").val();

                if (mode == modes.assigned) {
                    workflowUserSelectHelper.setDisabled(false);
                }
                else {
                    workflowUserSelectHelper.setValue("");
                    workflowUserSelectHelper.setDisabled(true);
                }

                // Clear errors
                workflowUserSelect.clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);